import { Capacitor } from '@capacitor/core';
import { supabase } from '@/integrations/supabase/client';

type EngagementEvent = 'opened' | 'destination_reached' | 'action_completed';

export async function recordNotificationEngagement(eventType: EngagementEvent, notificationId?: string | null, proactiveSendId?: string | null) {
  if (!notificationId && !proactiveSendId) return;
  const currentPlatform = Capacitor.getPlatform();
  const platform = currentPlatform === 'ios' || currentPlatform === 'android' ? currentPlatform : 'web';
  const { error } = await supabase.rpc('record_notification_engagement', {
    _notification_id: notificationId ?? undefined,
    _proactive_send_id: proactiveSendId ?? undefined,
    _event_type: eventType,
    _platform: platform,
  });
  if (error) console.error('[NotificationEngagement] record failed', error.message);
}

export function notificationContextFromUrl(search: string) {
  const params = new URLSearchParams(search);
  return { notificationId: params.get('notificationId'), proactiveSendId: params.get('proactiveSendId') };
}

export function recordNotificationAction() {
  const context = notificationContextFromUrl(window.location.search);
  return recordNotificationEngagement('action_completed', context.notificationId, context.proactiveSendId);
}